import { useMemo } from "react";
import { Select } from "../controls";
import { useSubCategories, sortOthersLast } from "../hooks/queries";

const SubCategoryDropdown = ({
  categoryId,
  name,
  value,
  onChange,
  onClick,
}: any) => {
  const { data = [] } = useSubCategories(categoryId);
  const cats = useMemo(
    () => sortOthersLast(data).map((k: any) => ({ label: k?.name, value: k?._id })),
    [data]
  );

  return (
    <Select
      name={name}
      title="Choose..."
      options={cats}
      showFirstOption={true}
      value={value}
      onChange={onChange}
      onClick={onClick}
    />
  );
};

export default SubCategoryDropdown;
